import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import ImageUploader from "@/components/ImageUploader";

export default function AdminSettings() {
  const [form, setForm] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setForm(r.data)); }, []);
  const set = (k, v) => setForm({ ...form, [k]: v });

  const save = async () => {
    try {
      const { data } = await api.put("/admin/settings", form);
      setForm(data);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Save failed");
    }
  };

  if (!form) return <div className="text-msr-slate" data-testid="admin-settings-loading">Loading...</div>;

  return (
    <div data-testid="admin-settings-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="overline mb-2">Settings</div>
          <h1 className="font-heading font-extrabold text-3xl tracking-tight">Site Settings</h1>
        </div>
        <button onClick={save} className="btn-msr-primary" data-testid="admin-settings-save-btn">Save Changes</button>
      </div>

      <div className="bg-white border border-msr-line p-6 grid lg:grid-cols-2 gap-5">
        <div className="lg:col-span-2 overline">Homepage</div>
        <Field label="Hero Title" value={form.hero_title} onChange={(v) => set("hero_title", v)} testId="settings-hero-title" />
        <Field label="Tagline" value={form.tagline} onChange={(v) => set("tagline", v)} testId="settings-tagline" />
        <div className="lg:col-span-2"><TextArea label="Hero Subtitle" value={form.hero_subtitle} onChange={(v) => set("hero_subtitle", v)} testId="settings-hero-subtitle" /></div>
        <div className="lg:col-span-2"><ImageUploader label="Hero image" value={form.hero_image} onChange={(v) => set("hero_image", v)} testId="settings-hero-image" /></div>

        <div className="lg:col-span-2 overline pt-4 border-t border-msr-line">Company</div>
        <Field label="Company Name" value={form.company_name} onChange={(v) => set("company_name", v)} testId="settings-company-name" />
        <Field label="Email" value={form.email} onChange={(v) => set("email", v)} testId="settings-email" />
        <Field label="Phone" value={form.phone} onChange={(v) => set("phone", v)} testId="settings-phone" />
        <Field label="Address" value={form.address} onChange={(v) => set("address", v)} testId="settings-address" />
        <div className="lg:col-span-2"><TextArea label="About (short)" value={form.about_short} onChange={(v) => set("about_short", v)} testId="settings-about-short" /></div>
        <div className="lg:col-span-2"><TextArea label="About (long)" value={form.about_long} onChange={(v) => set("about_long", v)} rows={5} testId="settings-about-long" /></div>

        <div className="lg:col-span-2 overline pt-4 border-t border-msr-line">Social</div>
        <Field label="Facebook URL" value={form.facebook_url} onChange={(v) => set("facebook_url", v)} testId="settings-fb" />
        <Field label="LinkedIn URL" value={form.linkedin_url} onChange={(v) => set("linkedin_url", v)} testId="settings-li" />
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testId }) {
  return (
    <label className="block text-xs font-semibold uppercase tracking-wider text-msr-slate">
      {label}
      <input type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="mt-1 block w-full border border-msr-line px-3 py-2.5 text-sm text-msr-ink font-normal normal-case tracking-normal focus:outline-none focus:border-msr-blue" data-testid={testId} />
    </label>
  );
}

function TextArea({ label, value, onChange, rows = 3, testId }) {
  return (
    <label className="block text-xs font-semibold uppercase tracking-wider text-msr-slate">
      {label}
      <textarea rows={rows} value={value || ""} onChange={(e) => onChange(e.target.value)} className="mt-1 block w-full border border-msr-line px-3 py-2.5 text-sm text-msr-ink font-normal normal-case tracking-normal focus:outline-none focus:border-msr-blue resize-none" data-testid={testId} />
    </label>
  );
}
